import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import TableChartOutlinedIcon from "@mui/icons-material/TableChartOutlined";
import PsychologyOutlinedIcon from "@mui/icons-material/PsychologyOutlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";

const FLOW_STEPS = [
  {
    label: "Upload",
    icon: UploadFileOutlinedIcon,
    title: "Start with your statement",
    guidelines: [
      {
        label: "Choose a file",
        text: "Use a P&L or management account statement.",
        details: [
          { label: "Formats", text: "Excel, PDF, JPEG/PNG, CSV or TXT." },
          { label: "Size", text: "Up to 5 MB. Word files are not supported." },
        ],
      },
    ],
    reminder: "Next, check the extracted table and identify its columns.",
  },
  {
    label: "Set up",
    icon: TableChartOutlinedIcon,
    title: "Choose the columns and AI tasks",
    guidelines: [
      {
        label: "Identify your columns",
        text: "Account Name and Amount are required.",
        details: [
          {
            text: "All other columns are optional. Multiple Amount columns are added together.",
          },
        ],
      },
      {
        label: "Choose the AI tasks",
        text: "Select at least one: P&L sections, tax treatment or merging similar accounts.",
        details: [{ text: "Merging also needs P&L Category enabled." }],
      },
      {
        label: "Set inference strictness",
        text: "Start with Medium (default).",
        details: [{ text: "Low makes fewer assumptions; High makes more." }],
      },
    ],
    reminder: "Next, review the snapshot before anything is sent to AI.",
  },
  {
    label: "Classify",
    icon: PsychologyOutlinedIcon,
    title: "Check what you are sending to AI",
    guidelines: [
      {
        label: "Review the snapshot",
        text: "Check the selected rows, amounts and AI tasks.",
      },
      {
        label: "Restore hidden values",
        text: "Replace placeholders such as <like this> with the original values.",
      },
      {
        label: "Confirm to start",
        text: "AI processes the rows in this snapshot.",
      },
    ],
    reminder:
      "Keep the window open until processing finishes. Larger files take longer.",
  },
  {
    label: "Review & apply",
    icon: FactCheckOutlinedIcon,
    title: "Check the result and apply it",
    guidelines: [
      {
        label: "Review and fix flagged rows",
        text: "Check names, amounts, sections and tax tags.",
        details: [
          { text: "To include a subtotal or ignored row, change its Section." },
        ],
      },
      {
        label: "Choose how to apply",
        details: [
          {
            label: "Add",
            text: "Keep existing P&L rows and append the new accounts.",
          },
          {
            label: "Replace",
            text: "Overwrite existing rows and remove their schedule links.",
          },
        ],
      },
    ],
    reminder:
      "After applying, click Save in Detailed P&L to save your changes.",
  },
];

const detailPLClassificationConfig = {
  subtitle: "Extract and classify financial statement accounts",
  classifyErrorMessage: "Accounts could not be classified. Please try again.",
  guideProps: { steps: FLOW_STEPS },
  uploadProps: {
    title: "Upload your financial document",
    description:
      "Upload financial statements, management P&L reports, or similar financial records. Our AI will automatically extract your data and classify each row for processing.",
  },
  loadingProps: { itemLabel: "account" },
};

export default detailPLClassificationConfig;
